module.exports = __webpack_public_path__ + "images/campaign-chat-gpt-bg-blog.webp";